export function getVimeoEmbedUrl(
  videoUrl: string,
  params: Record<string, string> = {},
): string | null {
  try {
    const url = new URL(videoUrl);
    if (!url.hostname.includes('vimeo.com')) return null;

    const rawPath = url.pathname.replace(/\/+$/, '');
    const id = rawPath.match(/(?:^|\/)(\d+)$/)?.[1];
    if (!id) return null;

    const embedUrl = new URL(`https://player.vimeo.com/video/${id}`);
    for (const [key, value] of url.searchParams.entries()) {
      embedUrl.searchParams.set(key, value);
    }
    for (const [key, value] of Object.entries(params)) {
      embedUrl.searchParams.set(key, value);
    }

    return embedUrl.toString();
  } catch {
    return null;
  }
}
